import FloatingElements from '../../FloatingElements'
import Module1 from '../Phone/Module1'
import Module2 from '../Phone/Module2'
import Module3 from '../Phone/Module3'
import ModuleMedallistsPhase1_5 from '../Phone/ModuleMedallistsPhase1_5'
import ModuleMedallistsPhase2 from '../Phone/ModuleMedallistsPhase2'
import ModuleMedallistsPhase3 from '../Phone/ModuleMedallistsPhase3'
import ModuleMedallistsPhase2_5 from '../Phone/ModuleMedallistsPhase3'
import Module5 from './Module5'

const Tablet = (props: any) => {
  return (
    <>
      <Module1 {...props} />
      {props?.medallistBlock === 'phase1.5MedallistAnnounced' && <ModuleMedallistsPhase1_5 {...props} />}
      {props?.medallistBlock === 'phase2MedallistAnnounced' && <ModuleMedallistsPhase2 {...props} />}
      {props?.medallistBlock === 'phase2.5MedallistAnnounced' && <ModuleMedallistsPhase2_5 {...props} />}
      {props?.medallistBlock === 'phase3MedallistAnnounced' && <ModuleMedallistsPhase3 {...props} />}
      <Module2 {...props} />
      <Module3 {...props} />
      <Module5 {...props} />
      <FloatingElements />
    </>
  )
}

export default Tablet
